<template>
    <div>
        <responsive-button variant="primary" @click="$bvModal.show(modalId)" :icon="['fas', 'eye']">
            View
        </responsive-button>
        <modal title="Results" size="lg" :id="modalId">
            <form-generator class="modal-form-generator" :isReadOnly="true" :onCompleted="() => null"
                :results="surveyResults" :surveyJSON="surveyJSON" />
        </modal>
    </div>
</template>

<script>
import ResponsiveButton from '../../../../generic/responsive-button/responsive-button.vue';
import Modal from '../../../../generic/modal/modal.vue';
import { prepareSurveyResults } from '../../../../hosted-form/hosted-form-page.vue';
import { defineAsyncComponent } from 'vue';

const FormGenerator = defineAsyncComponent(() =>
    import(
        /* webpackChunkName: "lx-form-generator" */
        '../../../../hosted-form/form-generator.vue'
    ))

export default {
    components: { ResponsiveButton, Modal, FormGenerator },
    computed: {
        modalId() {
            return 'view-form-modal-' + this.params.data.id;
        },
        surveyResults() {
            if (this.params.data.submitted_data) {
                const surveyResults = this.params.data.submitted_data
                const surveyObj = prepareSurveyResults(surveyResults, this.params.data.hosted_form_json.elements)
                return surveyObj
            }
            return {}

        },
        surveyJSON() {
            if (this.params.data.hosted_form_json) {
                const json = JSON.parse(JSON.stringify(this.params.data.hosted_form_json))
                json.title = this.params.data.hosted_form_json;
                // json.showNavigationButtons = false;
                return JSON.stringify(json);
            }
            return ''
        },
    }
};

</script>

<style lang="scss" scoped>
@import '../../../../hosted-form/styles.scss';

.modal-form-generator {
    :deep(.sv-components-row) {
        background-color: #f3f3f3;
    }
}
</style>